import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { CardComponent } from 'src/app/shared/ui-kit/card/card.component';

import { SharedBusinessMetadataComponentAbstract } from '../../../metadata-components/business-metadatas/shared-business-metadata/shared-business-metadata.component.abstract';

@Component({
  selector: 'app-shared-business-metadata-v2',
  standalone: true,
  imports: [CommonModule, CardComponent],
  templateUrl: './shared-business-metadata-v2.component.html',
})
export class SharedBusinessMetadataV2Component extends SharedBusinessMetadataComponentAbstract {}
